import * as config from "../config.js";

export const updateSupportingContentItem = async (
  supportingContentItemID,
  data
) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/item/${supportingContentItemID}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(data),
    }
  );

  const response = await results.json();
  return response;
};

export const createSupportingContentItem = async (content) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/item`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(content),
    }
  );

  const response = await results.json();
  return response;
};

export const updateSupportingContentItemStatus = async (
  supportingContentItemID,
  status
) => {
  const ustatus = status === "approve" ? "approve" : "reject";
  const url = `${config.REST_SERVER_URL}/admin/supportingcontent/${ustatus}/${supportingContentItemID}`;
  const results = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    }, credentials: "include",
  });

  const response = await results.json();
  return response;
};

export const getSupportingContentItem = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));
  console.log("!!! SUPPORTING CONTENT ITEM ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/item/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const supportingContent = await response.json();
  console.log("!!! SUPPRORTING CONTENT: ", supportingContent);
  if (supportingContent.success) {
    return supportingContent.supporting_content_item;
  }
  return null;
};

export const deleteSupportingContentItem = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));
  console.log("!!! SUPPORTING CONTENT ITEM ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/item/${public_id}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const supportingContent = await response.json();
  console.log("!!! SUPPRORTING CONTENT: ", supportingContent);
  return supportingContent;
};
